import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationPreReleaseClientPost = {
    path: "/pre-release-client",
    method: ERouteHttpVerb.POST
};
export { routeLocationPreReleaseClientPost };
